import React, { useCallback } from 'react';
import Entry from './Entry';
import PropTypes from 'prop-types';
import Explore from './Explore';
import changeLoginAction from '@gameday/app/lib/store/actions/loginAction';
import changeViewAction from '@gameday/app/lib/store/actions/views';
import { useDispatch } from 'react-redux';
import DiskStorage from 'disk-storage/disk-storage';
import changeUserInfoAction from '@gameday/app/lib/store/actions/userInfoAction';
import useTracking from '@gameday/utils/hooks/useTracking';

const hasLocalStorage = (typeof window !== 'undefined' && window.localStorage);

const noop = () => {};

export const TYPES = {
    PREVIEW: 'preview',
    LOGIN: 'login',
    REGISTER: 'register',
    EXPLORE: 'explore'
};

export const GamedayFVKey = 'gamedayFieldvision';
export const FVFirstRunKey = 'fieldvision.firstrun';

const Main = ({
    onClose,
    setFirstRunUser = noop,
    setComponentType,
    componentType,
    lockView = false,
    isSingleCol
}) => {
    const dispatch = useDispatch();
    const Tracking = useTracking();
    const onLoginSuccess = useCallback(() => {
        dispatch(changeLoginAction(true));

        if (hasLocalStorage) {
            const firstrun = DiskStorage.get(GamedayFVKey, FVFirstRunKey).value;

            if (firstrun !== null) {
                setFirstRunUser(false);
                if (!lockView) {
                    dispatch(changeViewAction({
                        fieldVisionOn: true
                    }));
                    // tracking fv
                    Tracking.track.track_fieldvision_pageload();
                }
                if (onClose && typeof onClose === 'function') {
                    onClose();
                }
            } else {
                setFirstRunUser(true);
                DiskStorage.put(GamedayFVKey, FVFirstRunKey, false, false);
                setComponentType(TYPES.EXPLORE);
            }
        }

        if (typeof window !== 'undefined' && window?.mlbOkta) {
            window.mlbOkta.isLoggedIn().then((res) => {
                dispatch(changeUserInfoAction({
                    accessToken: res?.accessToken?.accessToken
                }));
            });
        }
    }, [setComponentType, setFirstRunUser, onClose]);

    const onLoginError = useCallback(() => {}, []);

    return (
        <>
            {componentType === TYPES.EXPLORE ? <Explore isSingleCol={isSingleCol}/> : <Entry componentType={componentType} onLoginSuccess={onLoginSuccess} onLoginError={onLoginError} onRegisterSuccess={onLoginSuccess} setComponentType={setComponentType} />}
        </>
    );
};

Main.propTypes = {
    onClose: PropTypes.func,
    setFirstRunUser: PropTypes.func,
    setComponentType: PropTypes.func,
    componentType: PropTypes.string,
    lockView: PropTypes.bool,
    isSingleCol: PropTypes.bool
};

export default Main;
